<div class="dialog-container p-6">
    <div class="flex justify-between items-center mb-4">
        <h1 mat-dialog-title class="text-2xl font-bold">Configure Device Groups for Zone</h1>
        <button mat-icon-button (click)="onClose()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- Configured Groups -->
            <jjames-card>
                <div class="p-4">
                    <h2 class="text-xl font-semibold mb-4">Configured Groups</h2>
                    @if (isLoading()) {
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    }
                    @if (!isLoading() && configuredDeviceGroups().length === 0) {
                    <div class="text-center text-gray-500 py-4">
                        No device groups configured for this zone.
                    </div>
                    }
                    @if (!isLoading() && configuredDeviceGroups().length > 0) {
                    <mat-list>
                        @for (group of configuredDeviceGroups(); track group.id) {
                        <mat-list-item class="mb-2">
                            <mat-icon matListItemIcon>router</mat-icon>
                            <div matListItemTitle>{{ group.groupName }}</div>
                            <div matListItemLine>{{ group.groupDescription }}</div>
                            <div matListItemMeta>
                                <button mat-icon-button color="warn" (click)="removeGroup(group.id!)"
                                    [attr.aria-label]="'Remove ' + group.groupName">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </mat-list-item>
                        }
                    </mat-list>
                    }
                </div>
            </jjames-card>

            <!-- Add New Group -->
            <jjames-card>
                <div class="p-4">
                    <h2 class="text-xl font-semibold mb-4">Add New Group</h2>
                    <form [formGroup]="newGroupForm" (ngSubmit)="onAddNewGroup()">
                        <div class="flex flex-col gap-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Group Name</mat-label>
                                <input matInput formControlName="name" required>
                                @if (newGroupForm.get('name')?.hasError('required')) {
                                <mat-error>Name is
                                    required</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field appearance="fill">
                                <mat-label>Description</mat-label>
                                <textarea matInput formControlName="description"></textarea>
                            </mat-form-field>

                            <mat-form-field appearance="fill">
                                <mat-label>Type</mat-label>
                                <mat-select formControlName="type" required>
                                    @for (type of deviceGroupTypes; track type) {
                                    <mat-option [value]="type">
                                        {{ type }}
                                    </mat-option>
                                    }
                                </mat-select>
                                @if (newGroupForm.get('type')?.hasError('required')) {
                                <mat-error>Type is
                                    required</mat-error>
                                }
                            </mat-form-field>

                            <button mat-flat-button color="primary" type="submit" [disabled]="isSaving()">
                                @if (!isSaving()) {
                                <span>Add Group</span>
                                }
                                @if (isSaving()) {
                                <span>Adding...</span>
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </jjames-card>
        </div>
    </div>

    <div mat-dialog-actions class="pt-4 flex justify-end">
        <button mat-stroked-button (click)="onClose()">Done</button>
    </div>
</div>